// extracted by mini-css-extract-plugin
module.exports = {"logo":"Nav_logo__1nwp-","move":"Nav_move__2KaFc","header":"Nav_header__2lKBk","topHeader":"Nav_topHeader__1xxOI","navDrop":"Nav_navDrop__3oYtk","anticon":"Nav_anticon__VJU0L"};